type dynamicImport = [typeof import("react"), typeof import("react-dom")];

export default (): Promise<dynamicImport> => Promise.all([
  import(/* webpackChunkName: "react" */ "react"),
  import(/* webpackChunkName: "reactDOM" */ "react-dom")
]);
